<template>
    <div>
        <monitor-center-alert v-if="isShowAlertTemp" v-model="isShowAlertTemp" rightButtonTitle="绑定"
            @onRightButtonClick="onRightButtonClick">
        <template #top>
            <div class="appointment-bind-content">
                <div class="appointment-bind-content-top">
                    <p class="appointment-bind-content-top-name">{{ placeholderText(appointmentData.trueName) }} {{
                        formatAge(appointmentData.age) }}</p>
                    <!-- <p class="appointment-bind-content-top-age">{{ formatAge(appointmentData.age) }}</p> -->
                    <p class="appointment-bind-content-top-hospital">{{ placeholderText(appointmentData.hospitalName) }}
                    </p>
                </div>
                <div class="appointment-bind-content-selector-container">
                    <device-selector ref="deviceSelector" class="appointment-bind-content-selector-container-item" title="设备绑定"
                        :hospitalId="appointmentData.hospitalId || $store.state.selectedHospital.hospitalid"
                        :defaultSn="appointmentData.deviceSn"
                        :initValue="selectedDeviceId"
                        @onInitValueChanged="selectedDeviceId = $event"></device-selector>
                    <alert-time-selector class="appointment-bind-content-selector-container-item"
                        v-model="monitorDuration"></alert-time-selector>
                    <alert-selector title="使用时长" :dataArray="dataArray" v-model="period"></alert-selector>
                </div>
            </div>
        </template>
    </monitor-center-alert>
    
    <!-- 解绑确认弹框 -->
    <div v-if="isShowUnbindConfirm" class="unbind-confirm-mask" @click="onCancelUnbind">
        <div class="unbind-confirm-dialog" @click.stop>
            <div class="unbind-confirm-header">
                <h3>设备解绑确认</h3>
                <button class="unbind-confirm-close" @click="onCancelUnbind">✕</button>
            </div>
            <div class="unbind-confirm-content">
                <p class="unbind-confirm-text">
                    设备 <span class="device-sn">{{ selectedDeviceId }}</span> 当前已绑定用户：
                    <span class="user-name">{{ currentDeviceInfo?.userName || '-' }}</span>
                </p>
                <p class="unbind-confirm-warning">
                    确认解绑该设备并绑定给新用户吗？
                </p>
            </div>
            <div class="unbind-confirm-footer">
                <button class="unbind-confirm-btn cancel" @click="onCancelUnbind">取消</button>
                <button class="unbind-confirm-btn confirm" @click="onConfirmUnbind">确认解绑</button>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import MonitorCenterAlert from "@c/monitor-center/alert/monitor-center-alert.vue";
import DeviceSelector from "@c/monitoring-appointments/device-selector.vue";
import AlertSelector from "./alert-selector.vue";
import AlertTimeSelector from "./alert-time-selector/alert-time-selector.vue";
import { getKeyValueArray } from "@js/object-tool.js";
import { computeDurationStr } from "@c/monitor-center/alert/alert-selector/alert-time-selector/alert-time-selector-tool";
import { DateTool } from "@js/date-tool.js";

export default {
    components: {
        MonitorCenterAlert,
        DeviceSelector,
        AlertSelector,
        AlertTimeSelector
    },

    model: {
        prop: "isShowAlert",
        event: "onIsShowAlertChanged"
    },

    props: {
        isShowAlert: Boolean,
        appointmentData: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            isShowAlertTemp: undefined,
            selectedDeviceId: undefined,
            dataArray: getKeyValueArray(DEVICE_USE_PERIOD),
            period: undefined,
            monitorDuration: undefined,
            isShowUnbindConfirm: false, // 是否显示解绑确认弹框
            currentDeviceInfo: null, // 当前设备信息
        }
    },

    mounted() {
        this.isShowAlertTemp = this.isShowAlert;
        // 默认设置
        this.period = 1; // 默认1天 endTime: "6:00"
    },

    watch: {
        isShowAlertTemp(value) {
            this.$emit("onIsShowAlertChanged", value);
        },

        isShowAlert: {
            handler(value) {
                this.isShowAlertTemp = value;
            },
            immediate: true
        },
        appointmentData: {
            handler(value) {
                // 优先使用接口返回的 defaultMonitorPeriod
                if (value?.defaultMonitorPeriod) {
                    this.monitorDuration = this.parseDefaultMonitorPeriod(value.defaultMonitorPeriod);
                } else {
                    // 兼容旧逻辑：医院监控时间配置对象，便于添加定制化医院需求
                    const hospitalMonitorConfig = {
                        260: { // 雅安中医院定制
                            startTime: "21:00",
                            endTime: "08:00"
                        },
                        1708: { // 吉林大学白求恩第二医院
                            startTime: "22:00",
                            endTime: "05:00"
                        },
                        1210: { //舟山市第二人民医院
                            startTime: "20:30",
                            endTime: "05:30"
                        },
                        539: { //东莞市人民医院普济院区
                            startTime: "22:00",
                            endTime: "08:00"
                        }
                    }

                    // 获取默认配置
                    const defaultConfig = {
                        startTime: "21:00",
                        endTime: "06:00"
                    }

                    // 根据医院ID获取对应的配置，如果没有则使用默认配置
                    this.monitorDuration = value?.hospitalId && hospitalMonitorConfig[value.hospitalId]
                        ? hospitalMonitorConfig[value.hospitalId]
                        : defaultConfig
                }

                // 设置默认设备SN
                if (value?.deviceSn) {
                    console.log('value',value,value?.deviceSn)
                    this.selectedDeviceId = value.deviceSn;
                }
            },
            immediate: true
        }
    },

    methods: {
        placeholderText(text, unit) {
            if (!text || text === "null") {
                return "-";
            } else {
                const finalUnit = unit ? ` ${unit}` : "";
                return `${text}${finalUnit}`;
            }
        },

        formatDate(dateStr) {
            if (!dateStr) return "-";
            return DateTool.formatDate(DateTool.strToDate(dateStr), "Y-M-D");
        },

        formatAge(age) {
            if (!age || age === "null" || age === null) {
                return `${0}岁`;
            }
            return `${age}岁`;
        },


        async onRightButtonClick() {
            if (!this.selectedDeviceId) {
                this.$toast.showRed("请选择预绑信息");
                return;
            }
            
            try {
                // 首先检查设备状态
                await this.checkDeviceStatus();
            } catch (error) {
                this.$emit("onBindComplete", error);
            }
        },

        async checkDeviceStatus() {
            try {
                // 从设备选择器获取当前选择的设备信息
                const deviceSelector = this.$refs.deviceSelector;
                if (!deviceSelector) {
                    this.$toast.showRed("无法获取设备信息");
                    throw new Error("设备选择器不可用");
                }
                
                // 查找当前选择的设备
                const currentDevice = deviceSelector.dataArray.find(device => device.sn === this.selectedDeviceId);
                if (!currentDevice) {
                    this.$toast.showRed("设备信息不存在");
                    throw new Error("设备信息不存在");
                }
                
                this.currentDeviceInfo = currentDevice;
                
                // 检查设备状态：deviceStatus为1表示闲置，其他值表示已绑定需要解绑
                if (currentDevice.deviceStatus === 1) {
                    // 设备闲置，直接进行绑定
                    await this.performBinding();
                } else {
                    // 设备已绑定用户，显示解绑确认弹框
                    this.isShowUnbindConfirm = true;
                }
            } catch (error) {
                console.error('检查设备状态失败:', error);
                this.$toast.showRed("检查设备状态失败");
                throw error;
            }
        },

        onCancelUnbind() {
            this.isShowUnbindConfirm = false;
        },

        async onConfirmUnbind() {
            try {
                // 调用现有的解绑逻辑
                this.isShowUnbindConfirm = false;
                await this.performUnbind();
                
                // 刷新设备选择器的数据并等待完成
                if (this.$refs.deviceSelector && this.$refs.deviceSelector.getDeviceList) {
                    await this.$refs.deviceSelector.getDeviceList();
                }
                
                // 清除当前设备信息
                this.currentDeviceInfo = null;
                
                // 解绑成功后自动进行绑定
                await this.performBinding();
            } catch (error) {
                this.$emit("onBindComplete", error);
            }
        },

        async performUnbind() {
            try {
                const deviceStatus = this.currentDeviceInfo.deviceStatus;
                
                switch (deviceStatus) {
                    case DEVICE_BINDING_STATUS_CODE.已借出: // 终止后回收
                        const stopParams = { id: this.currentDeviceInfo.id };
                        await this.$api.stopDevice(stopParams);
                        const recycleParams = { 
                            sn: this.currentDeviceInfo.sn, 
                            detectionEquipmentStatus: DEVICE_RECYCLE_STATUS_CODE.完好 
                        };
                        await this.$api.deviceRecycle(recycleParams);
                        break;
                        
                    case DEVICE_BINDING_STATUS_CODE.待回收: // 直接回收
                        const directRecycleParams = { 
                            sn: this.currentDeviceInfo.sn, 
                            detectionEquipmentStatus: DEVICE_RECYCLE_STATUS_CODE.完好 
                        };
                        await this.$api.deviceRecycle(directRecycleParams);
                        break;
                        
                    default:
                        // 其他状态，直接回收设备
                        const defaultRecycleParams = { 
                            sn: this.currentDeviceInfo.sn, 
                            detectionEquipmentStatus: DEVICE_RECYCLE_STATUS_CODE.完好 
                        };
                        await this.$api.deviceRecycle(defaultRecycleParams);
                        break;
                }
            } catch (error) {
                console.error('设备解绑失败:', error);
                throw error;
            }
        },

        async performBinding() {
            try {
                const params = {
                    "sn": this.selectedDeviceId,
                    "hospitalId": this.appointmentData.hospitalId,
                    "userId": this.appointmentData.userId,
                    "monitor": computeDurationStr(this.monitorDuration),
                    "frequency": this.period
                }

                await this.$api.deviceBorrow(params);
                this.$emit("onBindComplete", null); // 绑定成功，传递null表示没有错误
            } catch (error) {
                console.error('设备绑定失败:', error);
                throw error;
            }
        },

        parseDefaultMonitorPeriod(period) {
            // 解析格式如 "22:00-08:00" 或 "22:00 - 08:00" 的字符串
            // 返回 { startTime, endTime } 格式
            if (period) {
                const parts = period.split(/-/).map(p => p.trim());
                if (parts.length === 2) {
                    return {
                        startTime: parts[0],
                        endTime: parts[1]
                    };
                }
            }
            // 解析失败返回默认值
            return {
                startTime: "21:00",
                endTime: "06:00"
            };
        }
    }
}
</script>

<style lang="scss" scoped>
.appointment-bind-content {
    display: flex;
    flex-direction: column;
    align-items: center;

    &-top {
        border-bottom: rem(1) solid #E6E4E9;
        width: 100%;

        &-name {
            color: #444C72;
            font-size: rem(16);
            line-height: rem(22);
            font-weight: 500;
        }

        &-age {
            color: #444C72;
            font-size: rem(14);
            line-height: rem(20);
            margin-top: rem(8);
        }

        &-hospital {
            color: #666666;
            font-size: rem(12);
            line-height: rem(17);
            margin-top: rem(8);
            margin-bottom: rem(20);
        }
    }

    &-selector-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: rem(20);
        margin-bottom: rem(20);

        &-item {
            margin-bottom: rem(20);
        }
    }
}

// 自定义解绑确认弹框样式
.unbind-confirm-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.unbind-confirm-dialog {
    background-color: white;
    border-radius: rem(8);
    width: rem(400);
    max-width: 90vw;
    box-shadow: 0 rem(4) rem(20) rgba(0, 0, 0, 0.15);
    
    .unbind-confirm-header {
        padding: rem(20) rem(20) rem(10) rem(20);
        border-bottom: rem(1) solid #f0f0f0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        h3 {
            margin: 0;
            color: #333;
            font-size: rem(16);
            font-weight: 600;
        }
        
        .unbind-confirm-close {
            background: none;
            border: none;
            font-size: rem(18);
            color: #999;
            cursor: pointer;
            padding: rem(4);
            line-height: 1;
            
            &:hover {
                color: #666;
            }
        }
    }
    
    .unbind-confirm-content {
        padding: rem(20);
        text-align: center;
        
        .unbind-confirm-text {
            color: #666;
            font-size: rem(14);
            line-height: rem(22);
            margin-bottom: rem(16);
            
            .device-sn {
                color: #325FAC;
                font-weight: 600;
            }
            
            .user-name {
                color: #F39920;
                font-weight: 600;
            }
        }
        
        .unbind-confirm-warning {
            color: #ff4d4f;
            font-size: rem(14);
            font-weight: 500;
            margin: 0;
        }
    }
    
    .unbind-confirm-footer {
        padding: rem(10) rem(20) rem(20) rem(20);
        display: flex;
        justify-content: flex-end;
        gap: rem(12);
        
        .unbind-confirm-btn {
            padding: rem(8) rem(16);
            border-radius: rem(4);
            font-size: rem(14);
            cursor: pointer;
            border: rem(1) solid;
            transition: all 0.2s;
            
            &.cancel {
                background-color: white;
                color: #666;
                border-color: #d9d9d9;
                
                &:hover {
                    color: #325FAC;
                    border-color: #325FAC;
                }
            }
            
            &.confirm {
                background-color: #ff4d4f;
                color: white;
                border-color: #ff4d4f;
                
                &:hover {
                    background-color: #ff7875;
                    border-color: #ff7875;
                }
            }
        }
    }
}
</style>